import { render } from "./ApplicationForm.vue?vue&type=template&id=bebd2ef2&scoped=true&ts=true"
import script from "./ApplicationForm.vue?vue&type=script&lang=ts"
export * from "./ApplicationForm.vue?vue&type=script&lang=ts"

import "./ApplicationForm.vue?vue&type=style&index=0&id=bebd2ef2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bebd2ef2"]])

export default __exports__